module.exports = __webpack_public_path__ + "static/media/chat-attachment.092638ce.svg";